module.exports = __webpack_public_path__ + "static/media/frankthemen.8c508dfe.png";